import React, { Component } from "react";
import ComplaintListCustomer from './ComplaintListCustomer';
import ComplaintListParticipant from './ComplaintListParticipant';
import { isSimilarObject } from "../../helper";

export default class Complaints extends Component {
    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const {isCustomer, executorStatus, complaints} = this.props;

        if(!complaints || !complaints.length) return null;

        if(isCustomer) {
            return  <ComplaintListCustomer
                        executorStatus={executorStatus}
                        complaints={complaints} />
        }

        return(
            <ComplaintListParticipant
                executorStatus={executorStatus}
                complaints={complaints} />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/ComplaintList.js